// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"d07792f3","66":"4956fe07","385":"351b1b14","453":"dbe0b4cf","455":"059ed545","463":"2b6eb00b","615":"d9d9d1f3","970":"569432fa","977":"e6bffeea"}[chunkId] + ".chunk.js";
};